<template>
  <v-app-bar
    id="core-app-bar"
    app
    color="white"
    elevate-on-scroll
    :height="$vuetify.breakpoint.smAndDown ? '90' : '96'"
  >
    <v-container>
      <v-row>
        <div class="d-flex align-center">
          <router-link to="/">
            <v-img
              :src="require('../../../assets/ColorfullyUniqueLogo.svg')"
              contain
              class="shrink mr-2 logo-image"
              height="80"
              width="196"
            />
          </router-link>
        </div>

        <v-spacer />

        <v-toolbar-items
          v-if="$vuetify.breakpoint.lgAndUp"
          class="shrink"
        >
          <v-btn
            v-for="(link, i) in theLinks"
            :key="i"
            :to="{
              name: link
            }"
            active-class="primary--text"
            class="subtitle-1 ml-1"
            exact
            min-width="128"
            text
          >
            {{ link }}
          </v-btn>
        </v-toolbar-items>

        <v-app-bar-nav-icon
          v-else
          @click="setDrawer(true)"
        />
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
  // Utilities
  import { mapMutations, mapState } from 'vuex'

  export default {
    name: 'CoreAppBar',

    computed: {
      ...mapState(['links']),
      theLinks () {
        let ret = this.links
        if (this.userIsAuthenticated) {
          ret = ret.filter(l => l !== 'Sign Up' && l !== 'Sign In')
        } else {
          ret = ret.filter(l => l !== 'User Area')
        }
        return ret
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    },

    methods: {
      ...mapMutations({
        setDrawer: 'setDrawer',
      }),
    },
  }
</script>

<style scoped>
/deep/ .primary--text {
  color: black !important
}

@media screen and (max-width: 600px) {
  .logo-image {
    height: 60px;
    width: 146px;
  }

  #core-app-bar {
    height: 100px !important;
  }
}
</style>
